/* eslint-disable react/prop-types */
import React from 'react';
import { Box, Typography } from '@mui/material';

import websitelogo from '../../../assets/logos/websitelogo.svg';
import './BrandedLoader.css';

function BrandedLoader({
	title = 'Loading',
	text = 'Preparing your MaxCharts workspace',
	minHeight = '80vh',
	className = '',
}) {
	return (
		<Box
			className={`branded-loader-wrap ${className}`.trim()}
			sx={{ minHeight }}
			role="status"
			aria-live="polite"
		>
			<Box className="branded-loader-card">
				<Box className="branded-loader-orbit" aria-hidden="true">
					<Box className="branded-loader-ring branded-loader-ring-one" />
					<Box className="branded-loader-ring branded-loader-ring-two" />
					<Box className="branded-loader-core">
						<img
							className="branded-loader-logo"
							src={websitelogo}
							alt=""
						/>
					</Box>
				</Box>
				<Typography className="branded-loader-title">{title}</Typography>
				{text ? (
					<Typography className="branded-loader-text">{text}</Typography>
				) : null}
				<Box className="branded-loader-dots" aria-hidden="true">
					<span />
					<span />
					<span />
				</Box>
			</Box>
		</Box>
	);
}

export default BrandedLoader;
